import React from 'react';

/**
 * Render employees
 * @param employees
 * @param contractor
 * @returns {*}
 */
export default ({ employees, contractor, uniqueKey }) => {
  if (!employees.length) {
    return null;
  }

  return employees.map((employee) => {
    const name = employee.id === contractor ? (<strong>{employee.name}</strong>) : employee.name;

    return (
      <span key={`${uniqueKey}:${employee.id}`} style={{ borderLeftColor: employee.color }}>
        {name}
      </span>
    );
  });
};



// WEBPACK FOOTER //
// ./src/components/Grid/Employees.js